import { Card, CardContent, CardMedia, Skeleton, Stack } from '@mui/material'

const SupplierListSkeleton = () => {
  return (
    <Card sx={{ borderRadius: 2, width: '100%' }}>
      <CardMedia>
        <Skeleton variant="rectangular" width="100%" height={157} />
      </CardMedia>
      <CardContent>
        <Stack spacing={1.5}>
          <Skeleton variant="text" width="60%" height={24} />
          <Skeleton variant="text" width="40%" height={20} />
          <Skeleton variant="rectangular" height={20} sx={{ borderRadius: 1 }} />
        </Stack>
      </CardContent>
    </Card>
  )
}

export default SupplierListSkeleton
